export const mainDiv = {
    height : '100%',
    width : '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};